'use strict';

//告知バー表示判定
if (document.querySelector('.announcement-bar-section') !== null) {
  document.body.classList.add('announcement-bar-true');
  window.addEventListener('scroll', function () {
    if (window.pageYOffset >= document.querySelector('.announcement-bar-section').offsetHeight) {
      document.body.classList.add('header-nav-fixed');
    } else if (window.pageYOffset > 0 && window.pageYOffset < document.querySelector('.announcement-bar-section').offsetHeight || window.pageYOffset <= 0 && document.body.getAttribute('style') === '' || window.pageYOffset <= 0 && document.body.getAttribute('style') === null) {
      document.body.classList.remove('header-nav-fixed');
    }
  });
} else {
  document.body.classList.add('header-nav-fixed');
}

//ページ先頭に戻るボタン
const pageTopButton = document.querySelector('.page-top');
window.addEventListener('scroll', function () {
  if (window.pageYOffset >= 144) {
    pageTopButton.classList.add('active');
  } else {
    pageTopButton.classList.remove('active');
  }
});

//ページ内リンク
let headerHeight;
const anchorLinks = document.querySelectorAll('a[href^="#"]');
function anchorLink() {
  for (let i = 0; i < anchorLinks.length; i++) {
    anchorLinks[i].onclick = function (event) {
      event.preventDefault();
      const href = anchorLinks[i].getAttribute('href');
      const target = document.getElementById(href.replace('#', ''));
      const rect = target.getBoundingClientRect().top;
      const offset = window.pageYOffset;
      const position = rect + offset - headerHeight;
      window.scrollTo({
        top: position,
        behavior: 'smooth',
      });
    };
  }
};
anchorLink();

//背景固定
const backFaceFixed = function (fixed) {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.body.style.paddingRight = fixed ? `${scrollbarWidth}px` : '';
  const scrollingElement = () => {
    const browser = window.navigator.userAgent.toLowerCase();
    if ('scrollingElement' in document) return document.scrollingElement;
    if (browser.indexOf('webkit') > 0) return document.body;
    return document.documentElement;
  };
  const scrollY = fixed
    ? scrollingElement().scrollTop
    : parseInt(document.body.style.top || '0');
  const styles = {
    height: '100vh',
    height: '100dvh',
    left: '0',
    overflow: 'hidden',
    position: 'fixed',
    top: `${scrollY * -1}px`,
    width: '100vw',
  };
  Object.keys(styles).forEach((key) => {
    document.body.style[key] = fixed ? styles[key] : '';
  });
  if (!fixed) window.scrollTo(0, scrollY * -1);
};

//ハンバーガーメニュー
hamburgerMenu();
function hamburgerMenu() {
  const details = document.querySelector('.hamburger-menu');
  const summary = details.querySelector('summary');
  const content = details.querySelector('.hamburger-content');
  summary.addEventListener('click', function (event) {
    event.preventDefault();
    if (details.open) {
      const closeDetails = content.animate(
        {
          transform: ['translateX(0)', 'translateX(32rem)'],
        },
        {
          duration: 250,
          easing: 'ease',
        }
      );
      closeDetails.onfinish = function () {
        details.open = false;
        if (details.parentElement.classList.contains('header-nav') === true) {
          backFaceFixed(false);
          document.body.classList.remove('hamburger-menu-open');
          document.querySelector('.hamburger-menu__inner').style.height = '';
        }
      }
    } else {
      details.open = true;
      if (details.parentElement.classList.contains('header-nav') === true) {
        backFaceFixed(true);
        document.body.classList.add('hamburger-menu-open');
        const scrollValue = document.querySelector('.header').getBoundingClientRect().top;
        document.querySelector('.hamburger-menu__inner').style.height = 'calc(100dvh - ' + (headerHeight + scrollValue) + 'px)';
      }
      const openDetails = content.animate(
        {
          transform: ['translateX(32rem)', 'translateX(0)'],
        },
        {
          duration: 250,
          easing: 'ease',
        }
      );
    }
  });
}

//折りたたみウィジェット
foldingWidget();
function foldingWidget() {
  const details = document.querySelectorAll('.folding-widget');
  details.forEach(function (element) {
    const summary = element.querySelector('summary');
    const content = element.querySelector('.folding-content');
    summary.addEventListener('click', function (event) {
      event.preventDefault();
      if (element.open) {
        const closeDetails = content.animate(
          {
            opacity: [1, 0],
            height: [content.offsetHeight + 'px', 0],
          },
          {
            duration: 250,
            easing: 'ease',
          }
        );
        closeDetails.onfinish = function () {
          element.open = false;
        }
      } else {
        element.open = true;
        const openDetails = content.animate(
          {
            opacity: [0, 1],
            height: [0, content.offsetHeight + 'px'],
          },
          {
            duration: 250,
            easing: 'ease',
          }
        );
      }
    });
  });
}

//ブラウザ幅判定
const navGlobalWrap = document.querySelector('.header-nav>details');
windowWidth();
function windowWidth() {
  const windowWidth = window.innerWidth;
  if (windowWidth >= 1200) {
    headerHeight = 144;
    navGlobalWrap.open = true;
    document.body.classList.remove('hamburger-menu-true');
  } else {
    headerHeight = 72;
    navGlobalWrap.open = false;
    document.body.classList.add('hamburger-menu-true');
  }
}

//リサイズ
let lastWindowWidth = window.innerWidth;
resize();
function resize() {
  let timer;
  window.onresize = function () {
    if (lastWindowWidth != window.innerWidth) {
      resizeStart();
      clearTimeout(timer);
      timer = setTimeout(function () {
        resizeEnd();
      }, 240);
    }
  };
};

//リサイズ開始時の処理
let resizeFlag = true;
function resizeStart() {
  if (resizeFlag === true) {
    resizeFlag = false;
  }
};

//リサイズ終了時の処理
function resizeEnd() {
  windowWidth();
  lastWindowWidth = window.innerWidth;
  resizeFlag = true;
};

//外部リンクを別窓で開く
const links = document.links;
for (let i = 0; i < links.length; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].classList.add('link_blank');
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}